<template>
    <span v-if="mostrarBtnCancelar">
        <b-button variant="danger" @click.stop="abrir()">
            <span> <i class="fa fa-minus-circle"></i> Cancelar Entrega</span>
        </b-button>
        <b-modal id="modalEvento" v-model="mostrarModal">
            <div slot="modal-title">Entrega - Cancelar</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.dataPrevistaInicio.$error ? false : null"
                        invalid-feedback="Data prevista para execução do serviço é obrigatória"
                    >
                        <label>Data Prevista para Execução do Serviço</label>
                        <date-picker
                            v-model="dataPrevistaInicio"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataPrevistaInicio.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="
                            $v.dataComunicacao.$invalid &&
                            $v.dataComunicacao.$model
                                ? false
                                : null
                        "
                        invalid-feedback="Data da comunicação do cancelamento é obrigatória e devem menor ou igual a data atual"
                    >
                        <label>Data da Comunicação do Cancelamento</label>
                        <date-picker
                            v-model="dataComunicacao"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.dataComunicacao.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Motivo</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposCancelamento"
                            v-model="tipoCancelamentoId"
                            text-field="descricao"
                            value-field="tipoCancelamentoId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Classificação</label>
                        <b-form-select
                            :plain="true"
                            :options="subTiposCancelamento"
                            v-model="subTipoCancelamentoId"
                            text-field="descricao"
                            value-field="tipoCancelamentoId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fechar()"
                    >Fechar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarCancelarEntrega()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-minus-circle"></i> Cancelar
                        Entrega</span
                    >
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            justificativa: null,
            dataPrevistaInicio: '',
            dataComunicacao: '',
            tiposCancelamento: [],
            tipoCancelamentoId: null,
            subTiposCancelamento: [],
            subTipoCancelamentoId: null
            // motivoForcaMaior: false
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.justificativa = null
            this.dataPrevistaInicio = ''
            this.dataComunicacao = ''
            // this.motivoForcaMaior = false
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarCancelarEntrega() {
            this.$swal({
                title:
                    this.entrega.temMaisEtapas == false
                        ? 'Cancelar Entrega'
                        : 'ATENÇÃO!!!',
                html:
                    this.entrega.temMaisEtapas == false
                        ? `Confirma o cancelamento da entrega?`
                        : `A contratação ainda tem mais entregas em aberto, você confirma o cancelamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.cancelarEntrega()
                }
            })
        },

        cancelarEntrega() {
            this.$store.dispatch('addRequest')
            let entregaCanceladaDto = {
                entregaId: this.$route.params.entregaId,
                dataPrevistaInicio: this.$moment(
                    this.dataPrevistaInicio,
                    'DD/MM/YYYY'
                ),
                dataComunicacao: this.$moment(
                    this.dataComunicacao,
                    'DD/MM/YYYY'
                ),
                justificativa: this.justificativa,
                tipoCancelamentoId: this.tipoCancelamentoId,
                subTipoCancelamentoId: this.subTipoCancelamentoId
            }
            this.entregasServicos
                .cancelarEntrega(entregaCanceladaDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Entrega cancelada com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.fechar()
                            this.$emit('obterEntregaAtualizada')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterTiposCancelemento() {
            this.$store.dispatch('addRequest')
            this.entregasServicos.obterTiposCancelamento().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposCancelamento = response.data
                        this.tipoCancelamentoId =
                            this.tiposCancelamento[0].tipoCancelamentoId
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de cancelamento!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        mostrarBtnCancelar() {
            return (
                this.$temAcesso('CRED-GEST-ENTR-03') &&
                (this.entrega.status === 0 || this.entrega.status == 3)
            )
        }
    },

    created() {
        if (this.$temAcesso('CRED-GEST-ENTR-03')) {
            this.obterTiposCancelemento()
        }
    },

    watch: {
        tipoCancelamentoId() {
            this.subTiposCancelamento = this.tiposCancelamento.filter((p) => {
                return p.tipoCancelamentoId == this.tipoCancelamentoId
            })[0].subTipos
            this.subTipoCancelamentoId = null
        }
    },

    validations: {
        dataPrevistaInicio: {
            required
        },
        dataComunicacao: {
            required,
            dataOk() {
                if (this.dataComunicacao) {
                    if (
                        this.$moment(
                            this.dataComunicacao,
                            'DD/MM/YYYY'
                        ).isSameOrBefore(new Date())
                    ) {
                        return true
                    }
                }
                return false
            }
        },
        justificativa: {
            required
        },
        subTipoCancelamentoId: {
            required
        }
    }
}
</script>
